module.exports = __webpack_public_path__ + "img/title2.4515309b.png";